var $ = require('jquery');

require('magnific-popup');

export module MagnificPopup {
  export function init(jsBlock:string) {
    var $items = $('.' + jsBlock);

    $items.each(function() {
      var $item = $(this),
          options = $item.data('mfp-options'),
          settings = {
            'items': null
          },
          inlineOnInit = $item.data('mfp-inline-on-init');

      // Open these immediately
      if (inlineOnInit) {
        $.magnificPopup.open({
          'items': {
            'src': $item,
            //'src': '<div>test</div>',
            'type': 'inline',
            'midClick': true
          }
        });
      } else if (options) {
        settings.items = options;
        $item.magnificPopup(settings);
      }
    });
  }
}
